import css from './Navbar.module.scss';
import { NavLink } from 'react-router-dom';
import {
  cloneElement,
  MouseEvent,
  ReactElement,
  useCallback,
  useMemo,
} from 'react';
import { MainMenuLogoProps } from '@epam/uui-components';

interface CustomMenuItemProps {
  isLoading: boolean;
  link: string;
  onNavClick?: (link: string) => void;
  caption?: string;
  children?: ReactElement<MainMenuLogoProps>;
}

const CustomMenuItem = ({
  caption,
  children,
  isLoading,
  link,
  onNavClick,
}: CustomMenuItemProps) => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      if (onNavClick && !isLoading) {
        onNavClick(link);
      } else {
        console.warn('Navigation is disabled');
      }
    },
    [onNavClick, isLoading, link],
  );

  const menuItemWithCaption = useMemo(
    () => (
      <NavLink
        className={({ isActive }) => `${css['navlink__uui-link']}
								${css['navlink__uui-button-box']}
								${css['navlink__uui-enabled']}
								${css['navlink__-clickable']}
								${isActive && css['navlink__uui-active']}
                ${isLoading && !isActive && css['navlink__uui-disabled']}`}
        to={link}
        onClick={handleClick}>
        <div className={css['navlink__uui-caption']}>{caption}</div>
      </NavLink>
    ),
    [link, isLoading, caption, handleClick],
  );

  const menuItemWithLogo = useMemo(() => {
    if (!children) return null;

    const props = {
      link: { pathname: link },
      onClick: handleClick,
    };

    return cloneElement(children, props);
  }, [children, link, handleClick]);

  return children ? menuItemWithLogo : menuItemWithCaption;
};

export default CustomMenuItem;
